import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-no-autorizado',
  templateUrl: './no-autorizado.component.html',
  styleUrls: ['./no-autorizado.component.css'],
})
export class NoAutorizadoComponent {
  readonly anioActual = new Date().getFullYear();

  constructor(
    private readonly router: Router,
    private readonly location: Location,
  ) { }

  volverInicio(): void {
    this.router.navigate(['/home']);
  }

  volverAtras(): void {
    this.location.back();
  }
}